export const monthlySubscriptionInfoTypes = [
    { code: 'MAIL', name: 'メール通知' },
    { code: 'WRITING', name: '書面通知' },
    { code: 'NOT_AVAILABLE', name: '対象外' }
];
